import React, { useState, useEffect } from "react";
import LayoutProvider from "../../../../providers/LayoutProvider";
import "./style.scss";
import StepFour from "../../../../components/Training/RequestSignature/StepFour";
import { useAppDispatch, useAppSelector } from "../../../../hooks/app";
import { getUserApiStatus, setStatusForStudentInstructor } from "../../../../store/slices/instructor-student.slice";
import { API_STATUS } from "../../../../constants";
import SpinnerLoader from "../../../../components/SpinnerLoader";
import { confirmAlert } from "react-confirm-alert";
import { Toaster } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import RequestSignatureService from "../../../../services/request-signatures.service";
import useCustomToast from "../../../../hooks/useCustomToast";
import InstructorPagesProvider from "../../../../providers/InstructorPagesProvider";

function ApproveRequestPage() {
    const [request, setRequest] = useState<any>({})
    const loading = useAppSelector(getUserApiStatus)

    const [signature, setSignature] = useState(null);
    const customToast = useCustomToast()
    const navigate = useNavigate()

    const dispatch = useAppDispatch()
    const { id } = useParams();

    const setFile = (file: any) => {
        setSignature(file)
    }
    const getRequest = async () => {
        const res: any = await RequestSignatureService.getSingleRequest(id as string)
        if (res) {
            setRequest(res)
        }
    }

    useEffect(() => {
        if (id) {
            getRequest()
        }
    }, [id])



    const handleSubmitRequest = async (e: React.FormEvent, status: string) => {
        e.preventDefault()
        confirmAlert({
            title: 'Confirm',
            message: `Are you sure you want to ${status == "1" ? "approve" : "cancel"} this request?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: async () => {
                        dispatch(setStatusForStudentInstructor(API_STATUS.LOADING))
                        const formData = new FormData()
                        if (signature) {
                            formData.append("signature", signature)
                        }
                        formData.append("status", status)
                        const res: any = await RequestSignatureService.updateRequestStatus(id as string, formData)
                        if (res?.status === 200) {
                            customToast(res?.message, "success")
                            setTimeout(() => {
                                navigate("/training/request-signatures")
                            }, 1500)
                        }
                        dispatch(setStatusForStudentInstructor(API_STATUS.IDEAL))
                    },
                },
                {
                    label: 'No',
                    onClick: () => { },
                },
            ],
        })
    }

    return (
        <InstructorPagesProvider>
            <LayoutProvider>
                <Toaster />
                {loading === API_STATUS.LOADING && <SpinnerLoader />}
                <div className="create_request_signature">
                    <h2 className="heading2 ">Request Signatures</h2>
                    <div className="wrapper">
                        <h3 className="heading3 mb-3">
                            Received Signature Request Details
                        </h3>

                        <form>
                            <div className="stepper__content">
                                <StepFour request={request} setFile={setFile} />
                            </div>
                            {request?.status == 0 && <div className="d-flex gap-2">
                                <button className="btn btn-danger mt-3 w-100 text-center" onClick={(e) => handleSubmitRequest(e, "2")}>
                                    Cancel
                                </button>
                                <button className="button submit mt-3 w-100 text-center" onClick={(e) => handleSubmitRequest(e, "1")}>
                                    Approve
                                </button>
                            </div>}
                        </form>
                    </div>
                </div>
            </LayoutProvider>
        </InstructorPagesProvider>
    );
}

export default ApproveRequestPage;
